import { NgModule } from '@angular/core';
import { ScheduleSettingsComponent } from './schedule-settings/schedule-settings.component';
import { WizardComponent } from './wizard/wizard.component';
import { DayOfWeekPipe } from './dayofweek.pipe';
import { NoticeTimeCardComponent } from './notice-time-card/notice-time-card.component';
import { MeetingBufferCardComponent } from './meeting-buffer-card/meeting-buffer-card.component';
import { MeetingBeforeBufferCardComponent } from './meeting-before-buffer-card/meeting-before-buffer-card.component';
import { MeetingAppCardComponent } from './meeting-app-card/meeting-app-card.component';
import { DurationMultiSelectComponent } from './duration-multi-select/duration-multi-select.component';
import { CalendarCardComponent } from './calendar-card/calendar-card.component';
import { AvailabilityIncrementCardComponent } from './availability-increment-card/availability-increment-card.component';
import { AvailabilityCardComponent } from './availability-card/availability-card.component';
import { AdvancedAvailabilityCardComponent } from './advanced-availability-card/advanced-availability-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LayoutModule } from '@angular/cdk/layout';
import { ScheduledMeetingsGuard } from '../scheduled-meetings.guard';
import { EditAvailabilityDialogComponent } from './advanced-availability-card/edit-availability-dialog';
import { VaStatusBannerModule } from '@vendasta/uikit';
import { MatStepperModule } from '@angular/material/stepper';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MeetingIntegrationsModule } from '../meeting-integrations/meeting-integrations.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ScheduleSettingsPageComponent } from './schedule-settings-page.component';
import { VaFormsModule } from '@vendasta/forms';
import { NavigationModule } from '../sales-center-navigation/navigation.module';
import { MeetingSchedulerSharedModule } from '../shared/meeting-scheduler-shared.module';
import { CalendarModule } from '../calendar/calendar.module';
import { GalaxyTimezoneSelectorModule } from '@vendasta/galaxy/timezone-selector';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { AddToWebsiteComponent } from './add-to-website/add-to-website.component';
import { SalesCoachUserSettingsComponent } from './sales-coach-user-settings/sales-coach-user-settings.component';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { AlertComponent } from '@vendasta/galaxy/alert/src/alert.component';
import { GalaxyStickyFooterModule } from '@vendasta/galaxy/sticky-footer';

@NgModule({
  declarations: [
    DayOfWeekPipe,
    ScheduleSettingsPageComponent,
    ScheduleSettingsComponent,
    WizardComponent,
    NoticeTimeCardComponent,
    MeetingBufferCardComponent,
    MeetingBeforeBufferCardComponent,
    MeetingAppCardComponent,
    DurationMultiSelectComponent,
    CalendarCardComponent,
    AvailabilityIncrementCardComponent,
    AvailabilityCardComponent,
    AdvancedAvailabilityCardComponent,
    EditAvailabilityDialogComponent,
    AddToWebsiteComponent,
    SalesCoachUserSettingsComponent,
  ],
  imports: [
    GalaxyTimezoneSelectorModule,
    TranslateModule,
    MatTooltipModule,
    LayoutModule,
    RouterModule,
    VaStatusBannerModule,
    MatStepperModule,
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MeetingIntegrationsModule,
    MeetingSchedulerSharedModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDividerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NavigationModule,
    VaFormsModule,
    CalendarModule,
    GalaxyFormFieldModule,
    MatRadioGroup,
    MatRadioButton,
    FormsModule,
    CdkCopyToClipboard,
    GalaxyTooltipModule,
    MatSlideToggleModule,
    GalaxyBadgeModule,
    AlertComponent,
    GalaxyStickyFooterModule,
  ],
  providers: [ScheduledMeetingsGuard],
  exports: [ScheduleSettingsPageComponent, AdvancedAvailabilityCardComponent, AddToWebsiteComponent],
})
export class MeetingSchedulerSettingsModule {}
